module.exports = __webpack_public_path__ + "static/media/CheckMark.35a3a555.svg";